module.exports = __webpack_public_path__ + "img/transferMoney.71ba53fa.svg";